import { FC, useState } from 'react';
import './SubmittedLoginForm.scss';
import { ReactComponent as ArrowIcon } from '../../../assets/icons/arrow-left.svg';
import LetterIcon from '../../../assets/icons/message.png';
import SendAgainTimer from './SendAgainTimer';
import { sendMagicLinkToEmail } from '../../../api/auth';
import { checkEmail } from '../../../api/members';
import Card from '../../BaseComponents/Card';

interface IProps {
  email: string;
  onBack: () => void;
}

const SubmittedLoginForm: FC<IProps> = ({ email, onBack }) => {
  const [isSendAgainLoading, setIsSendAgainLoading] = useState<boolean>(false);

  const sendAgain = async () => {
    try {
      setIsSendAgainLoading(true);
      
      // First check if email exists
      const emailCheckResponse = await checkEmail(email);
      if (emailCheckResponse.status !== 'success') {
        console.error('Email check failed:', emailCheckResponse.description || 'Email not allowed');
        return;
      }

      // If email check passes, send magic link
      await sendMagicLinkToEmail(email);
    } catch (error) {
      console.error('Error during login process:', error);
    } finally {
      setIsSendAgainLoading(false);
    }
  };
  return (
    <Card backgroundColor={'rgba(247, 249, 252, 1)'}>
      <div className='submitted-form-wrapper'>
        <div className='arrow-wrapper'>
          <ArrowIcon onClick={onBack} className='back-arrow' />
        </div>
        <div className='main-content-container'>
          <img
            src={LetterIcon}
            onClick={onBack}
            className='letter-icon'
            alt='letter'
          />
          <p className='submitted-form-title'>Check your email</p>
          <p className='submitted-form-subtitle'>
            We sent an email to you at <b>{email}</b>.<br />
            It has a magic link that’ll log in
          </p>
        </div>

        <div className='email-info-container'>
          <SendAgainTimer
            sendAgain={sendAgain}
            isSendAgainLoading={isSendAgainLoading}
          />
        </div>
      </div>
    </Card>
  );
};

export default SubmittedLoginForm;
